/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".box-filter[_ngcontent-%COMP%], .box-parent[_ngcontent-%COMP%] {\n  background: #FFFFFF;\n  padding: 1.5em 2em 20px 2em !important;\n  border-radius: 10px;\n  box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.2); }\n\n.box-parent[_ngcontent-%COMP%] {\n  border-radius: 10px; }\n\n.padding-left[_ngcontent-%COMP%] {\n  padding-left: 75px; }\n\n.backgroundcompany[_ngcontent-%COMP%] {\n  width: 200px;\n  padding-left: 10px; }"];
export { styles as styles };



// WEBPACK FOOTER //
// /opt/app/src/app/features/power-bi-dashboard/overdue-debt/overdue-debt.component.scss.shim.ngstyle.js.pre-build-optimizer.js